// Arquivo debug.ts
// Funções para depuração

/**
 * Logger avançado para depuração
 * @param title Título do log
 * @param data Dados a serem logados
 */
export function debugLog(title: string, ...data: any[]) {
  console.log(`%c[DEBUG] ${title}`, 'background: #333; color: #bada55; padding: 2px 4px; border-radius: 2px;', ...data);
}

/**
 * Compara dois valores e loga o resultado
 * @param a Primeiro valor
 * @param b Segundo valor
 * @param label Descrição da comparação
 */
export function compareAndLog(a: any, b: any, label: string) {
  const isEqual = String(a) === String(b);
  const color = isEqual ? '#4CAF50' : '#F44336';
  
  console.log(
    `%c[COMPARE] ${label}: ${isEqual ? 'IGUAL' : 'DIFERENTE'}`,
    `background: ${color}; color: white; padding: 2px 4px; border-radius: 2px;`
  );
  console.log(`  - Valor A: '${a}' (${typeof a})`);
  console.log(`  - Valor B: '${b}' (${typeof b})`);
}

/**
 * Função para verificar e converter IDs para string
 * @param id O ID a ser normalizado
 * @returns ID convertido para string e com espaços removidos
 */
export function normalizeId(id: any): string {
  if (id === undefined || id === null) {
    console.warn('ID indefinido ou nulo detectado!');
    return '';
  }
  return String(id).trim();
}